module.exports = __webpack_public_path__ + "static/profile-a3522f9be97b1aed7e8d38d186da01b6.jpg";